export default __webpack_public_path__ + "static/homeBg-a9c5a07f63a5934d91d5fbe6b382c2c7.png";